import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 2rem;
  padding: 1.5rem;
  background: ${({ theme }) => theme.colors.background_white};
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  h2 {
    font-size: 1.25rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.secondary};
    margin-bottom: 1rem;
  }

  .history-scroll {
    max-height: 400px;
    overflow-y: auto;
    padding-right: 0.5rem;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: ${({ theme }) => theme.colors.background};
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.colors.primary};
      border-radius: 3px;
    }
  }

  .historyItem {
    margin-bottom: 1.5rem;
    padding-bottom: 1.5rem;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);

    &:last-child {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
    }
  }

  .historyItemContainer {
    margin-top: 0.5rem;
  }

  .historyItemContent {
    .historyText {
      font-size: 0.9rem;
      color: ${({ theme }) => theme.colors.secondary};
      margin-bottom: 0.5rem;

      strong {
        font-weight: 600;
        color: ${({ theme }) => theme.colors.primary};
      }
    }

    .changesList {
      margin-top: 0.75rem;
      padding-left: 1rem;
    }

    .changeItem {
      font-size: 0.85rem;
      color: ${({ theme }) => theme.colors.text};
      margin-bottom: 0.25rem;
      line-height: 1.4;
    }

    .valueChange,
    .dateChange {
      font-size: 0.85rem;
      color: ${({ theme }) => theme.colors.text};
      margin-top: 0.5rem;
      padding: 0.5rem;
      background: ${({ theme }) => theme.colors.background};
      border-radius: 4px;
    }
  }
`;
